module.exports = __webpack_public_path__ + "static/media/logomini.4948cf22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/logomini.svg
// module id = 649
// module chunks = 11